import React from "react";

export default function StatBlock({ label, value, accent }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md p-4">
      <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
        {label}
      </div>
      <div className={`mt-1 font-heading text-xl font-bold ${accent || "text-slate-900"}`}>
        {value}
      </div>
    </div>
  );
}
